export class MarkerClusterPrice {

    public lessEqual: number;
    public greaterEqual: number;
    public calculationType: string;

    constructor(obj: Partial<MarkerClusterPrice>) {
        Object.assign(this, obj);
    }

}
